import { contatos_empty } from "@/components/Form/Contatos/get_contacts_empty";
import { endereco_empty } from "@/components/Form/Endereco/get_endereco_empty";
export const getPagination = ({ pagination }) => pagination;

export const oportunidade_empty = () => ({
  origem: "",
  nome: "",
  codigo: "",
  descricao: "",
  objeto: "",
  descricao: "",
  tipo_instrumento_id: null,
  acao_transferencia_especial: "",
  moeda_id: null,

  valor_projeto: "",
  valor_total: "",

  data_disponibilizacao: "",
  data_proposta_ini: "",
  data_proposta_fim: "",
  data_proposta_fim_tipo: "determinada",

  criterios: "",
  outras_informacoes: "",
  imagem: {
    image_file: null,
    legenda: "",
    tags: null,
  },
  campos_dinamicos: {},
  ods: [],
  areas: [],
  instituicoes_tipos: [],
  concedente_contatos: [],
  qualificacao_propostas: [],
  qualificacao_propostas_emenda: null,
  estados: [],
  oportunidades_estados: [],
  municipios: [],
  status_exibicao: "edicao",
  categorias: [],
  modalidade_emenda: [],
  contrapartidas: [],
  beneficios: [],
  beneficios_concedente: [],
  emendas: [],
  cronograma: [],

  galeria_arquivo: [],
  galeria_modelo: [],

  plataforma_id: null,
  como_submeter_envio: [],
  como_submeter_descricao: null,
  como_submeter_meio: [],
  como_submeter_contato: null,
  como_submeter_email: null,
  como_submeter_url: null,
  como_submeter_name: null,

  endereco: endereco_empty(),
  contatos: contatos_empty(),
});

export const cronograma_empty = () => ({
  oportunidade_id: null,
  data_evento: null,
  descricao: null,
});

export const qualificacao_proposta = () => [
  {
    value: "emenda-parlamentar",
    text: "Emenda Parlamentar",
    children_text: "Modalidade da Emenda",
    children: [
      {
        value: "transferencia-finalidade-definida",
        text: "Transferência com Finalidade Definida",
      },
      {
        value: "transferencia-especial-custeio",
        text: "Transferência Especial de Custeio",
      },
      {
        value: "transferencia-especial-investimento",
        text: "Transferência Especial de Investimento",
      },
      {
        value: "transferencia-assistencia-social",
        text: "Transferência da Assistência Social",
      },
      {
        value: "transferencia-saude",
        text: "Transferência da Saúde",
      },
    ],
  },
  {
    value: "especifica-concedente",
    text: "Específica do Concedente",
  },
  {
    value: "voluntaria",
    text: "Proposta Voluntária",
  },
];

export const oportunidade_estatistica_empty = () => ({
  beneficios: {
    total: null,
    max: null,
    min: null,
    media: null,
  },
  beneficios_concedente: {
    total: null,
    max: null,
    min: null,
    media: null,
  },
  emendas: {
    total: null,
    max: null,
    min: null,
    media: null,
  },
});

export const tipos_contrapartida = () => [
  { value: "financeira", text: "Financeira" },
  { value: "bens-servico", text: "Bens e serviços" },
  { value: "negociavel", text: "Negociável" },
];
